var _defs, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _ellipse3, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _path29, _path30, _path31, _path32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotlightMonochromatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 187.35 159.88",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 61.98,
    y1: 95.96,
    x2: 101.22,
    y2: 150.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 81.17,
    y1: 58.51,
    x2: 200.73,
    y2: 58.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 95.24,
    y1: 90.27,
    x2: 46.77,
    y2: 119.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 58.78,
    y1: 104.19,
    x2: 111.89,
    y2: 142.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 80.15,
    y1: 93.5,
    x2: 99.62,
    y2: 93.5,
    gradientTransform: "translate(79.07 -35.75) rotate(39.09)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 57.52,
    y1: 108.2,
    x2: 68.74,
    y2: 118.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 355.91,
    y1: 14.59,
    x2: 280.52,
    y2: 7.1,
    gradientTransform: "translate(-196.16 81.74) rotate(-6.39)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 307.75,
    y1: 19.1,
    x2: 337.93,
    y2: 11.86,
    gradientTransform: "translate(-196.16 81.74) rotate(-6.39)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 114.23,
    y1: 54.44,
    x2: 120.12,
    y2: 59.46,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 117.68,
    y1: 55.92,
    x2: 119.8,
    y2: 61.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 115.54,
    y1: 55.61,
    x2: 131.78,
    y2: 65.1,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M190.29,88c-3.34,4.74-7.45,9.14-9.19,14.67a39.88,39.88,0,0,0-1.34,9.5c-.7,10.89-1.87,22.14-7.3,31.61a39.2,39.2,0,0,1-25.87,18.65c-19.44,3.93-40.08,2.25-59.31-1.9C62.9,155.32,34.49,147,22.2,123.39a80.25,80.25,0,0,1-2.45-67.92c4.17-9.62,10.66-18.74,20.08-23.37C50.68,26.78,63,28.31,74.6,26.74c9.64-1.3,20.14-6.33,29-10.28,4.73-2.1,9.45-4.31,14.29-6.09a91.15,91.15,0,0,1,60.72-.69c13.41,4.61,20,23.45,21.6,36.33C202.08,60.59,198.8,76,190.29,88Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#9c46f8",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56,126.31s-2.17,3.36,3.69,4.41l21.51-14.35L98.6,113.8l3.13-3.79L89.89,104.8l-19.08,6.33Z",
    transform: "translate(-13.38 -4.81)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190.29,88c-3.34,4.74-7.45,9.14-9.19,14.67a39.88,39.88,0,0,0-1.34,9.5L96,105.82l-14.83-23,22.46-66.31c4.73-2.1,9.45-4.31,14.29-6.09a91.15,91.15,0,0,1,60.72-.69c13.41,4.61,20,23.45,21.6,36.33C202.08,60.59,198.8,76,190.29,88Z",
    transform: "translate(-13.38 -4.81)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.21,70.3",
    transform: "translate(-13.38 -4.81)",
    fill: "#9c46f8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6,104.23l-2.43,1.49-.17.1a16.24,16.24,0,0,1-7.85,2.33l-3.11.28-.39,0A15.41,15.41,0,0,0,77,111.34L56.44,126.28l-.47,0a6,6,0,0,1-3-.68h0a5.93,5.93,0,0,1-2.76-7.38l.11-.28,19.58-15.07a10.53,10.53,0,0,0,3.94-6.45L74.27,94l.08-.44a13.29,13.29,0,0,1,2.83-6.06L80.91,83Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#9c46f8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6,104.23l-2.43,1.49-.17.1a16.24,16.24,0,0,1-7.85,2.33l-3.11.28c-6-3-10.17-8.31-10.77-14.47l.08-.44a13.29,13.29,0,0,1,2.83-6.06L80.91,83Z",
    transform: "translate(-13.38 -4.81)",
    fill: "url(#linear-gradient-3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.17,105.72l-.17.1a16.24,16.24,0,0,1-7.85,2.33l-3.5.31A15.41,15.41,0,0,0,77,111.34L56.44,126.28l-.47,0a6,6,0,0,1-3-.68h0l22.76-18.46,9.37-5.4Z",
    transform: "translate(-13.38 -4.81)",
    fill: "url(#linear-gradient-4)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.89,
    cy: 93.5,
    rx: 9.22,
    ry: 13.82,
    transform: "translate(-52.21 72.79) rotate(-39.09)",
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.89,
    cy: 93.5,
    rx: 7.96,
    ry: 11.93,
    transform: "translate(-52.21 72.79) rotate(-39.09)",
    fill: "#9c46f8"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.89,
    cy: 93.5,
    rx: 7.96,
    ry: 11.93,
    transform: "translate(-52.21 72.79) rotate(-39.09)",
    fill: "url(#linear-gradient-5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.35,111.52a1.29,1.29,0,0,0-.53.63,1.33,1.33,0,0,0,.26,1c.16.26.34.55.64.63a1.17,1.17,0,0,0,.89-.23,25.13,25.13,0,0,0,2.15-1.36,1.72,1.72,0,0,0,.72-.77c.27-.78-.49-2.23-1.4-1.79A18,18,0,0,0,59.35,111.52Z",
    transform: "translate(-13.38 -4.81)",
    fill: "url(#linear-gradient-6)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.39,111.28a.8.8,0,0,0-.35.4.88.88,0,0,0,.17.64.59.59,0,0,0,1,.26q.7-.4,1.38-.87a1.09,1.09,0,0,0,.45-.5c.18-.5-.31-1.43-.89-1.14A10.92,10.92,0,0,0,60.39,111.28Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#9c46f8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.51,80.23c1.07-.24,2.07-.69,3.12-1a.87.87,0,0,1,.55,0,.66.66,0,0,1,.3.83,1.91,1.91,0,0,1-.62.74l-1.31,1.1a7.64,7.64,0,0,1-2.32,1.5,1.34,1.34,0,0,1-1.42-.16c-.12-.12-.19-.28-.3-.41-.32-.38-.87-.49-1.23-.85s-.41-1.67.39-1.74a13.62,13.62,0,0,1,1.36.21A5.65,5.65,0,0,0,151.51,80.23Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#ffbbab"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M149.55,83.77A1.07,1.07,0,0,0,150,84a1.26,1.26,0,0,0,.58,0,4.85,4.85,0,0,0,1.06-.27,5.16,5.16,0,0,0,1.1-.71c.54-.41,1.07-.83,1.58-1.27a2.78,2.78,0,0,0,1.22-2.13.71.71,0,0,0-.1-.35A.78.78,0,0,0,155,79a2.86,2.86,0,0,0-1.86.21c-.59.23-1.14.56-1.75.75a3.38,3.38,0,0,0-.82.31,1.19,1.19,0,0,0-.49.78,3.14,3.14,0,0,1-.09.75c-.18.45-.77.49-1,.89S149.29,83.54,149.55,83.77Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#9c46f8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.68,82.47a.92.92,0,0,0-.53.16,1.13,1.13,0,0,0-.26.45c-.57,1.49-1.08,3-1.55,4.52a2,2,0,0,0-.12.76c.07.55.59.9,1.06,1.19.29.17.75.28.86,0s-.1-.39-.12-.6a.91.91,0,0,1,.32-.66l3.56-4a1.17,1.17,0,0,0-.49-1.88,5.35,5.35,0,0,0-1.19.09C115.71,82.49,115.2,82.43,114.68,82.47Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#ffbbab"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M116.05,82.93a1.68,1.68,0,0,1-.3.92,4.92,4.92,0,0,0-.71,2.07A6.84,6.84,0,0,1,115,87c-.08.39-.32.74-.4,1.14-.11.6.15,1.27-.14,1.81a1.31,1.31,0,0,1-1.88.29,2.63,2.63,0,0,1-.91-1.88,9.41,9.41,0,0,1,.83-4.35A3.1,3.1,0,0,1,114.3,82C114.93,81.79,116,82.2,116.05,82.93Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#9c46f8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130.61,71.66s-1.48,8.44-2.06,8.69-11,4.17-11,4.17l-.71-2.08s3.22-2.57,6.64-5.16c1.17-.89,1.08-5.46,1.33-6.69S130.61,71.66,130.61,71.66Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#282328"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124.72,69.92s1.1,3.73,2.54,4.68,9.94,2.55,9.94,2.55,3.53,1.91,4.73,2.36S148,82,148,82l1-2.11-8-6.39a20.2,20.2,0,0,0-2.4-1.27c-.64-.2-8.13-4.48-8.13-4.48Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#473f47"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M122.65,54.37a2.5,2.5,0,0,0-.94,1.27c-.47,1.32-1,2.81-.18,4.1A27.16,27.16,0,0,1,123,62.12a18.9,18.9,0,0,1,1.45,6.67c.07.74,1.12.89,1.85.92a8.22,8.22,0,0,0,4-.93.82.82,0,0,0,.29-.23.75.75,0,0,0,.07-.57c-.15-1.21-.36-2.42-.43-3.64a10.15,10.15,0,0,1,.05-1.83c.08-.58,0-1.18,0-1.77s.08-1,.08-1.45a2.75,2.75,0,0,0-.35-1.38c-.28-.45-.65-.85-1-1.27a12.8,12.8,0,0,1-1-1.44,4.3,4.3,0,0,0-.66-1,2.84,2.84,0,0,0-2.33-.61A5.34,5.34,0,0,0,122.65,54.37Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#ffbbab"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M130.63,47.07a6.63,6.63,0,0,0,.71-1.92,10.94,10.94,0,0,0,.07-2.56,2.21,2.21,0,0,0-.23-.88c-.22-.37-.62-.61-.8-1a.21.21,0,0,1,0-.13.2.2,0,0,1,.13-.11l.44-.21a1.6,1.6,0,0,1,0-1.08.68.68,0,0,1,.57-.51c.29,0,.49.29.76.41s.55.1.79.23a1.4,1.4,0,0,1,.5.82,6.91,6.91,0,0,1,.06,2.4,20.44,20.44,0,0,1-.18,2.71A21.7,21.7,0,0,1,132,50.49a19.53,19.53,0,0,1-1.31,2.63c-.54.93-2.55,4.56-3.78,3.94-1.67-.84-1-2.83-.17-3.89A29.24,29.24,0,0,0,130.63,47.07Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#ffbbab"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M125.38,53.32c.64.68,1.25,1.38,1.85,2.09a1.06,1.06,0,0,1,.34.8.88.88,0,0,1-.34.49,2.52,2.52,0,0,1-2.44.22,7.73,7.73,0,0,1-2.12-1.42,4,4,0,0,0-1.19-.76,1.33,1.33,0,0,0-1.33.21.83.83,0,0,0,0,1.23c-.08-.35.33-.66.68-.62a1.56,1.56,0,0,1,.9.55,12,12,0,0,1,.95,1.06,3.25,3.25,0,0,1,.55.88,3.2,3.2,0,0,1-.42,2.45,2.74,2.74,0,0,0-.34.9,2.77,2.77,0,0,0,.36,1.39,19.58,19.58,0,0,1,1.33,5.87,1.34,1.34,0,0,0,.42,1,1.19,1.19,0,0,0,.79.1c1.28-.17,2.48-.73,3.76-.93a19,19,0,0,0,2.39-.3c.1,0,.22-.06.27-.16a.45.45,0,0,0,0-.36,25.25,25.25,0,0,1-1.34-6.57,15,15,0,0,0,0-3.14,1.77,1.77,0,0,0-.24-.64,2.23,2.23,0,0,0-.49-.48,9,9,0,0,1-2.34-3.12",
    transform: "translate(-13.38 -4.81)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M124,64.09c.09.36.24.77.59.9a1,1,0,0,1,.29.1c.2.12.22.38.3.6a3.48,3.48,0,0,0,.83,1c.3.33.52.84.26,1.2s-.49.33-.62.58.2,1-.13,1.27a.5.5,0,0,1-.66-.08,1.51,1.51,0,0,1-.31-.65q-1-3.66-2-7.34a1.11,1.11,0,0,1-.06-.4,1.34,1.34,0,0,1,.14-.38c.13-.26.26-.74.49-.91.34.36.29,1.29.37,1.76C123.59,62.54,123.77,63.32,124,64.09Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#020202",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M127.45,48.52c.16.19.36.36.39.59a1.08,1.08,0,0,1-.09.5,3.36,3.36,0,0,0-.08,1.14,1.44,1.44,0,0,1-.07.85,1.29,1.29,0,0,1-.91.52l-.81.15a.57.57,0,0,0-.29.08.51.51,0,0,0-.18.25,6.38,6.38,0,0,0-.12,2,.69.69,0,0,1-.08.32.63.63,0,0,1-.23.2,2.47,2.47,0,0,1-1.78.33.76.76,0,0,1-.41-.2.84.84,0,0,1-.13-.49,8.92,8.92,0,0,1,0-1.37,5.19,5.19,0,0,0,.05-1.84c-.14-.53-.49-1-.67-1.5a2.67,2.67,0,0,1,1.08-3,3.19,3.19,0,0,1,2.74-.28c.33.1.59.14.79.43S127.12,48.12,127.45,48.52Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#ffbbab"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M126.52,45a1.71,1.71,0,0,0-.73-.86,2.89,2.89,0,0,0-2-.12,5,5,0,0,0-2.17,1,2.55,2.55,0,0,0-1,2.1.81.81,0,0,0-.55.53,1.66,1.66,0,0,0,0,.8,5.55,5.55,0,0,0,1.61,2.76c.26.28.74,1,1.17.94s.46-.71.69-1c-.24-.17-.52-.28-.75-.46a.78.78,0,0,1-.32-.77c.09-.28.52-.41.68-.17a2.49,2.49,0,0,1,.42-2.14.88.88,0,0,1,.25-.29,1,1,0,0,1,.35-.12c.34-.06.68-.11,1-.14s.73,0,1-.34a1.75,1.75,0,0,0,.4-1.24A1.43,1.43,0,0,0,126.52,45Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#fc682d"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M124.69,52.59a.36.36,0,0,0-.24.13.38.38,0,0,0,0,.28,6.74,6.74,0,0,0,.29,1.46,1.11,1.11,0,0,0,.16.35.38.38,0,0,0,.35.15c.15,0,.25-.17.39-.23a.6.6,0,0,1,.49,0,2.38,2.38,0,0,1,.4.31,7.17,7.17,0,0,0,.94.7A6.91,6.91,0,0,0,126.22,54a.91.91,0,0,0-.47-.31c-.14,0-.3,0-.42-.08s-.08-.41,0-.62.26-.52.08-.63S124.81,52.56,124.69,52.59Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#e0a194"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M127,49.79a4.09,4.09,0,0,0-.61.1s-.06,0-.08,0a.19.19,0,0,0,0,.07,1.41,1.41,0,0,0,.21.94.64.64,0,0,0,.27.27.34.34,0,0,0,.36,0,.59.59,0,0,0,.13-.29,2,2,0,0,0,0-1,.05.05,0,0,0,0,0,.07.07,0,0,0-.06,0,.86.86,0,0,0-.39,0",
    transform: "translate(-13.38 -4.81)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M128.41,50.31l.09-.06C128.45,50.24,128.41,50.26,128.41,50.31Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#9c46f8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M121.27,55.38a7.42,7.42,0,0,0-.46,3.55,17.41,17.41,0,0,0,1.25,3.14c.86,2.57,1.31,5.25,2.25,7.79a1.42,1.42,0,0,0,.48.73,1.41,1.41,0,0,0,1,0l.71-.16a48.22,48.22,0,0,0,5-1.45.89.89,0,0,0,.68-1.36,45.23,45.23,0,0,1-.92-6.86,20.63,20.63,0,0,0-.62-3.3,3.47,3.47,0,0,1-.28-1.68,1.5,1.5,0,0,1,.19-.49,18.93,18.93,0,0,1,1.28-1.56,6.93,6.93,0,0,0,1-3.16c.24-1.61.51-3.22.72-4.83.17-1.19-.49-1.58-1.39-1.85l-1.05-.29a16.78,16.78,0,0,1-.63,3.67,5.69,5.69,0,0,1-2,2.93.08.08,0,0,1,.08.06c0,.07,0,.15-.07.22L126.64,53a1.35,1.35,0,0,1-.44.42c-.21.09-1,0-.91.37a.25.25,0,0,0,0,.07c.06.13.18.23.22.36a.46.46,0,0,1-.17.47,1,1,0,0,1-.5.18,1.89,1.89,0,0,1-.58,0c-.72-.15-1.77-.66-2.48-.21a1.57,1.57,0,0,0-.52.74Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#9c46f8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M133.61,45.79c-.22,1.61-.48,3.22-.73,4.83a6.81,6.81,0,0,1-1,3.16,17.39,17.39,0,0,0-1.28,1.56,2.28,2.28,0,0,0-.2.45.2.2,0,0,1-.07-.06c-.18,3.45.94,6.87,1.68,10.28a3.55,3.55,0,0,1-.17,2.76A3.71,3.71,0,0,1,129,70a2.59,2.59,0,0,1-1,0c-1.07-.23-1.53-1.48-1.81-2.54l-.16-1.15a70.09,70.09,0,0,1-1.86-8.21,2.25,2.25,0,0,1,.16-1.58,2.49,2.49,0,0,1,1.13-.8,18.21,18.21,0,0,0,3.06-1.83,1.55,1.55,0,0,1,1.07-.44.52.52,0,0,1-.08-.26.65.65,0,0,1,0-.2c.47-1.16.9-2.33,1.37-3.47a10.23,10.23,0,0,0,.84-3.4,6.93,6.93,0,0,1,.1-1.51,1.92,1.92,0,0,1,.3-.63C133.12,44.21,133.77,44.6,133.61,45.79Z",
    transform: "translate(-13.38 -4.81)",
    fill: "url(#linear-gradient-7)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M119.74,66.26a1.1,1.1,0,0,0,.16.56,1.08,1.08,0,0,0,.67.34c3.08.67,6.28.21,9.39-.26a1.22,1.22,0,0,0,1.24-1.06l.38-1.12c.09-.25.16-.57,0-.75a.68.68,0,0,0-.49-.12l-7,.08a20.75,20.75,0,0,1,.12-3,4.84,4.84,0,0,0-.63-2.93,2.28,2.28,0,0,0-2.26-1.05c-.89.29-.9,1.36-1.09,2.23A23.7,23.7,0,0,0,119.74,66.26Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#9c46f8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M124.49,56.57A3.25,3.25,0,0,0,123,58.85c-.48,1.67-.89,3.37-1.22,5.07A1.16,1.16,0,0,0,122,65a1.11,1.11,0,0,0,.49.23,15.37,15.37,0,0,0,6.88.18,2.2,2.2,0,0,0-1.6-.84L125,64c-.54-.11-1.2-.34-1.27-.89a1.17,1.17,0,0,1,0-.49l.51-2a.33.33,0,0,1,.36.23",
    transform: "translate(-13.38 -4.81)",
    fill: "url(#linear-gradient-8)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M132.6,66a4.54,4.54,0,0,0,.93-.7,5.48,5.48,0,0,0,1.1-1.21.51.51,0,0,0,.11-.31c0-.24-.29-.38-.53-.39a5.75,5.75,0,0,0-1.4.35c-.66.14-1.4,0-1.95.34s-1.26,1.51-.7,2S132.06,66.29,132.6,66Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#ffbbab"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "114.47 60.34 120.6 59.54 126.67 54.22 126.67 45.7 119.6 50.45 119.6 55.18 118.97 55.47 114.47 60.34",
    fill: "#473f47"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "119.6 55.18 119.43 58.95 115.67 59.49 118.97 55.47 119.6 55.18",
    fill: "url(#linear-gradient-9)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "118.36 56.5 119.29 56.44 118.34 57.89 117.11 58 118.36 56.5",
    fill: "url(#linear-gradient-10)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "119.55 56.33 118.08 58.71 119.45 58.51 119.55 56.33",
    fill: "url(#linear-gradient-11)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "133.61 31.89 141.12 53.02 168.91 43.05 168.91 42.15 141.71 52.02 134.59 31.22 133.61 31.89",
    fill: "#9c46f8"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "145.52 50.64 141.16 39.82 143.74 38.43 148.71 49.48 145.52 50.64",
    fill: "#9c46f8"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "151.84 48.23 144.94 30.75 147.52 29.36 155.03 47.07 151.84 48.23",
    fill: "#9c46f8"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "159.12 45.7 149.97 22.13 152.55 20.74 162.32 44.54 159.12 45.7",
    fill: "#9c46f8"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "151.26 58.59 151.26 71.43 168.91 71.43 168.91 70.93 151.87 70.93 151.84 64.44 151.82 58.42 151.26 58.59",
    fill: "#9c46f8"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.29 67.31 156.84 65.25 153.48 67.1 153.22 66.64 157 64.56 158.32 66.44 160.9 63.28 162.93 64.1 168.76 60.12 169.06 60.56 163 64.69 161.06 63.92 158.29 67.31",
    fill: "#9c46f8"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "119.14 26.78 108.41 25.12 113.21 15.34 123.94 17 119.14 26.78",
    fill: "#9c46f8"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "118.59 23.61 107.86 21.95 112.66 12.17 123.4 13.83 118.59 23.61",
    fill: "#9c46f8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M121.78,29.93s-1.86-1.47-.54-3.17L132,28.42s-.74,2,.55,3.17Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#9c46f8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M132.52,31.6l-10.73-1.67s-1.87-1.47-.55-3.17L132,28.42a4,4,0,0,0-.14.58,2.83,2.83,0,0,0,.49,2.39Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#9c46f8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M132.32,31.39,122,29.79a1.72,1.72,0,0,1-.41-2.38L131.83,29A2.83,2.83,0,0,0,132.32,31.39Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M132.32,31.39,137,21.76a4.83,4.83,0,0,1-.2-3.12L131.83,29A2.89,2.89,0,0,0,132.32,31.39Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.32,31.21,137,21.57s-.59-.82-.2-2.93l-4.94,10.18A2.89,2.89,0,0,0,132.32,31.21Z",
    transform: "translate(-13.38 -4.81)",
    fill: "#9c46f8",
    opacity: 0.43,
    style: {
      isolation: "isolate"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotlightMonochromatic);
export default __webpack_public_path__ + "static/media/Spotlight _Monochromatic.ce46b014cd83f501c78f633adb961fa6.svg";
export { ForwardRef as ReactComponent };